import { handleError } from "@/utils/error";
import { Query } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useClient, usePollClient } from "creso-core/hooks";
import { Client } from "creso-core/types";
import { useEffect } from "react";
import { toast } from "sonner";
import { Button } from "web-design-system";
import {
  ClientStatusLayout,
  clientStatusContentClassName,
  type ClientStatusMemberDisplay,
} from "./client-status-layout";

function refetchCriteria(query: Query<Client>) {
  const { data } = query.state;

  if (data?.status === "ACTIVE") return false;

  return 5000;
}

export function UnderReview({
  client: initialClient,
  memberDisplay,
}: {
  client: Client;
  memberDisplay?: ClientStatusMemberDisplay;
}) {
  const clientId = initialClient.id;

  const { data: client, refetch, isFetching } = useClient(clientId, false);

  const { data: polledClient } = usePollClient(
    { id: clientId },
    {
      refetchInterval: refetchCriteria,
      enabled:
        !!clientId && (client ?? initialClient)?.status === "UNDER_REVIEW",
    }
  );

  const router = useRouter();

  useEffect(() => {
    if (polledClient?.status !== "ACTIVE") return;
    toast.success("Account is now activated, and ready for transactions");
    router.invalidate();
  }, [polledClient?.status, router]);

  return (
    <ClientStatusLayout memberDisplay={memberDisplay}>
      <div
        className={clientStatusContentClassName(
          memberDisplay,
          "justify-between gap-2"
        )}
      >
        <p className="text-sm">
          Account details submitted and will be activated in a few minutes.
        </p>
        <Button
          disabled={isFetching}
          onClick={() => {
            refetch()
              .then(({ data: client }) => {
                if (client?.status === "ACTIVE") {
                  toast.success(
                    "Account is now activated, and ready for transactions"
                  );
                } else {
                  toast.info(
                    "Account is still under review and will be activated shortly"
                  );
                }
              })
              .catch((e) => handleError(e, "Failed to check status"));
          }}
          variant="outline"
        >
          Check Status
        </Button>
      </div>
    </ClientStatusLayout>
  );
}
